import { asyncStorageStorage } from "@lookiero/sty-psp-storage";
const asyncStorageUiSettings = () => asyncStorageStorage();
export { asyncStorageUiSettings };
